/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SzkolenieTo } from '../../models/szkolenie-to';

export interface ApiWebInstytucjeNipSzkoleniaGet$Params {
  nip: string;
}

export function apiWebInstytucjeNipSzkoleniaGet(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipSzkoleniaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SzkolenieTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipSzkoleniaGet.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SzkolenieTo>>;
    })
  );
}

apiWebInstytucjeNipSzkoleniaGet.PATH = '/api/web/instytucje/{nip}/szkolenia';
